import { formSet } from "../gvc/testNewForm/utils";
import { validationFns } from "../../components/form/validations";
import { IpSetInput } from "../../schema/types/ipset/input";
import { parseLink } from "../../utils/linkParser/linkParser";

export function getValidator(id: string) {
  return async function validator(v: IpSetInput): Promise<boolean | null> {
    // setup
    formSet(id, `meta.valid`, false);
    formSet(id, `meta.validating`, true);
    formSet(id, `errors`, {});
    formSet(id, `warnings`, {});

    const e: Partial<Record<string, { message: string }>> = {};
    const w: Partial<Record<string, { message: string }>> = {};

    function setError(path: string, message: string) {
      const currentError = e[path];
      if (currentError) {
        return;
      }
      e[path] = { message: message };
    }

    function setWarning(path: string, message: string) {
      const currentError = e[path];
      if (currentError) {
        return;
      }
      const currentWarning = w[path];
      if (currentWarning) {
        return;
      }
      w[path] = { message: message };
    }

    // setup end

    try {
      const fs = validationFns("Name");
      for (const f of [fs.required, fs.name]) {
        const r = f(v.name);
        if (r !== true) {
          setError(`name`, r);
        }
      }

      if (v.description.length > 250) {
        setError(`description`, `Description can be at most 250 characters`);
      }

      if (v.target === "gvc") {
        if (v.gvc?.value) {
          const parsedLink = parseLink(v.gvc.link, { useInputCtx: true });
          if (!parsedLink.isValid) {
            setError(`gvc`, parsedLink.errorMessage);
          }
        }
      }
      if (v.target === "workload") {
        if (v.workload?.value) {
          const parsedLink = parseLink(v.workload.link, { useInputCtx: true });
          if (!parsedLink.isValid) {
            setError(`workload`, parsedLink.errorMessage);
          }
        }
      }

      // tags start
      for (const tagIndexStr in v.tags) {
        const tagIndex = Number(tagIndexStr);
        const tag = v.tags[tagIndex];
        if (!tag.name) {
          setError(`tags.${tagIndex}.name`, "Tag key is required");
          setError(`tagsroot`, "Tag keys are required");
        }
      }

      if (v.tags.length > 50) {
        setError(`tagsroot`, "Tags cannot be more than 50 items");
      }
      // tags end

      // locations start
      for (const indexStr in v.locations) {
        const index = Number(indexStr);
        const l = v.locations[index];
        if (!l.location.value) {
          setError(`locations.${index}.location`, "Location is required");
          setError(`locationsroot`, "Locations are required");
        }
      }
      // locations end

      // setup
      for (const path of Object.keys(e)) {
        const value = e[path];
        formSet(id, `errors.${path}`, value);
      }
      for (const path of Object.keys(w)) {
        const value = w[path];
        formSet(id, `warnings.${path}`, value);
      }

      const hasErrors = Object.keys(e).length > 0;

      formSet(id, `meta.valid`, !hasErrors);
      formSet(id, `meta.validating`, false);

      return hasErrors;
    } catch (e) {
      formSet(id, `errors`, { root: e.message });
      return true;
    }
  };
}
